import Fansipan from '../images/Sa Pa - Fansipan.jpg';
import Lake from '../images/Sa Pa - Lake.jpg';
import SunPlaza from '../images/Sa Pa - Sun Plaza.jpg';
import Funicular from '../images/Sa Pa Funicular Train.jpg';
import OldQuarter from '../images/Hanoi - Old Quarter.jpg';

export const menuData = [
  { title: 'Home',      link: '#home',      image: Fansipan   },
  { title: 'Details',   link: '#details',   image: Funicular  },
  { title: 'Gallery',   link: '#gallery',   image: SunPlaza   },
  { title: 'Our Story', link: '#our-story', image: Lake       },
  { title: 'RSVP',      link: '#rsvp',      image: OldQuarter },
];
